var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "company-introduction"
  }, [_c("section", {
    staticClass: "company-introduction__banner-wrapper"
  }, [_c("Banner", {
    attrs: {
      title: "关于我们",
      description: "将同花顺30多年的技术积累和数字化转型经验开放出来，用AI引领金融科技，携手客户互联合作共创价值。",
      showAppoint: false
    }
  })], 1), _c("section", {
    staticClass: "company-introduction__profile-wrapper"
  }, [_c("Profile")], 1), _c("section", {
    staticClass: "company-introduction__honour-wrapper"
  }, [_c("Honour")], 1), _c("section", {
    staticClass: "company-introduction__culture-wrapper"
  }, [_c("Culture")], 1), _c("section", {
    staticClass: "company-introduction__process-wrapper"
  }, [_c("Process")], 1), _c("section", {
    staticClass: "company-introduction__contact-wrapper"
  }, [_c("Contact")], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };